import React, { useState, useEffect, useCallback } from "react";
import { useForm } from "react-hook-form";
import { useAtendimentoPage } from "../../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../../Context/Historico";
import { useUserInfor } from "../../../../../Context/User";
import { ListarProdutosPorContaCompleto } from "../../../../../Controllers/Cobranca/ContaProduto/ContaProdutoController";
import { AtualizarAtendimentoController } from "../../../../../Controllers/Geral/Atendimentos/AtendimentosController";
import { ListarCategoriaAtendimentoAoClienteController } from "../../../../../Controllers/Geral/GestaoDeCadastros/CategoriaAtendimento";
import { ListarSubCategoriaController } from "../../../../../Controllers/Geral/GestaoDeCadastros/SubCategoria/SubCategoriaControllers";
import { ListarCanalAtendimentoContoller } from "../../../../../Controllers/Geral/GestaoDeCadastros/TipoCanalAtendimento/TipoCanalAtendimentoController";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { IContaProduto } from "../../../../../Interfaces/Cobranca/ContaProduto/ContaProdutoInterface";
import { IAtualizarAtendimento } from "../../../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import { ACESSOS } from "../../../../../Routes/Acessos";
import { Spinner } from "../../../../Loding/SpinnerPadrao";
import LazySelect from "../../../Forms/LazySelect";
import SelectCategoriaAtendimento from "../../../Forms/SelectCategoriaAtendimento";
import { ListarTipoPesoAtendimentoAtivosController } from "../../../../../Controllers/Geral/GestaoDeCadastros/TipoPesoAtendimento/TipoPesoAtedimentoControllers";
import { useModuloInfo } from "../../../../../Context/ModuloInfo";
import { VendasListarOrigensLeadController } from "../../../../../Controllers/Vendas/OrigemLead/OrigemLeadController";
import { MoneyReaisFieldMask } from "../../../../../Validations/InputMasks";
import { formatMoneyReais } from "../../../../../Tools/FormatTools";
import { EditarOportunidadeLeadController } from "../../../../../Controllers/Vendas/Oportunidade/OportunidadeController";
import OrSpinner from "../../../../Utils/OrSpinner";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";

const controllers = {
    Atendimento: {
        Categoria: ListarCategoriaAtendimentoAoClienteController,
        Subcateogoria: ListarSubCategoriaController,
        Produto: ListarProdutosPorContaCompleto,
        id: ACESSOS.ATENDIMENTO.ID_MODULO,
    },
};

interface IEditarAtendimentoProps {
    setShow: (show: boolean) => void;
}

export default function EditarAtendimento(props: IEditarAtendimentoProps) {
    const { ReloadHistorico } = useHistoricoContext();
    const { UserInfor } = useUserInfor();
    const { id } = useModuloInfo();

    const {
        Atendimento,
        TIPO_CASO,
        updateAtendimento,
        idModulo,
        Cliente,
        GetCliente,
        dadosOportunidade,
        dadosOportunidadeLoading,
    } = useAtendimentoPage();

    const formMethods = useForm();
    const {
        handleSubmit,
        watch,
        setValue,
        setError,
        clearErrors,
        register,
        control,
        formState,
    } = formMethods;

    const [produtos, setProdutos] = useState<Array<IContaProduto>>([]);
    const [showJustificativa, setShowJustificativa] = useState(false);

    const dtExpectativaInicial = Atendimento?.DT_EXPECTATIVA_CONCLUSAO
        ? Atendimento?.DT_EXPECTATIVA_CONCLUSAO.split("T")[0]
        : Atendimento?.DT_SLA?.split("T")[0];
    const watchDtExpectativaNova = watch("DT_EXPECTATIVA_NOVA");

    const ListarProdutosCliente = useCallback(
        async () =>
            TIPO_CASO === "Atendimento" && Atendimento?.ID_CONTA
                ? controllers[TIPO_CASO].Produto(
                      Atendimento?.ID_CONTA,
                      idModulo
                  )
                : ([] as Array<IContaProduto>),
        [Atendimento?.ID_CONTA, TIPO_CASO, idModulo]
    );

    const ListarSubCategorias = useCallback(
        async (idCategoria: number, idUnidade: number) => {
            const idEmpreendimento = produtos.find(
                (p) => p.UNIDADE.ID_UNIDADE === idUnidade
            )?.ID_EMPREENDIMENTO;
            return ListarSubCategoriaController(idCategoria, idEmpreendimento);
        },
        [produtos]
    );

    const { loading: atualizando, execute: handleEditarAtendimentoFormSubmit } =
        useAsyncCallback(async (formdata: IAtualizarAtendimento) => {
            function finalizarAtualizacao() {
                props.setShow(false);
                updateAtendimento();
                ReloadHistorico();
                if (GetCliente) GetCliente();
            }

            if (
                watchDtExpectativaNova &&
                watchDtExpectativaNova !== dtExpectativaInicial &&
                watch("DS_MOTIVO").length === 0
            ) {
                setError("DS_MOTIVO", {
                    type: "required",
                    message: "Insira a justificativa",
                });
                return;
            }

            if (Atendimento?.ID_CASO) {
                await AtualizarAtendimentoController(Atendimento.ID_CASO, {
                    ...formdata,
                    ID_TIPO_CASO: idModulo,
                    DT_EXPECTATIVA_ANTERIOR: dtExpectativaInicial,
                }).then(async () => {
                    if (ACESSOS.VENDAS.ID_MODULO === idModulo) {
                        await EditarOportunidadeLeadController({
                            DT_FECHAMENTO: formdata.DT_FECHAMENTO || undefined,
                            ID_OPORTUNIDADE: Atendimento.ID_OPORTUNIDADE,
                            NR_PROBABILIDADE_FECHAMENTO:
                                (formdata.NR_PROBABILIDADE_FECHAMENTO ?? 0) /
                                    100 || undefined,
                            VL_OPORTUNIDADE:
                                formdata.VL_OPORTUNIDADE || undefined,
                        }).then(finalizarAtualizacao);
                    } else {
                        finalizarAtualizacao();
                    }
                });
            }
        });

    const { execute: listarCanalAtendimento } = useAsyncCallback(
        () => ListarCanalAtendimentoContoller(),
        []
    );

    useEffect(() => {
        if (
            watchDtExpectativaNova &&
            watchDtExpectativaNova !== dtExpectativaInicial
        ) {
            setShowJustificativa(true);
        } else {
            setShowJustificativa(false);
        }
    }, [
        watchDtExpectativaNova,
        dtExpectativaInicial,
        setError,
        clearErrors,
        setValue,
    ]);

    const { value: lstTipoPesoAtendimento, loading: lstTipoPesoAtendimentoLoading } = useAsyncEffect(async () => {
        if (id) return ListarTipoPesoAtendimentoAtivosController(id);
    }, [id]);

    return (
        <OrSpinner loading={dadosOportunidadeLoading || lstTipoPesoAtendimentoLoading} spinner="capys">
            <form onSubmit={handleSubmit(handleEditarAtendimentoFormSubmit)}>
                {TIPO_CASO === "Atendimento" && (
                    <LazySelect
                        label="Produto"
                        name="ID_PRODUTO"
                        controller={ListarProdutosCliente}
                        defaultValue={Atendimento?.ID_PRODUTO}
                        getDS={(p) =>
                            `${p.DS_EMPREENDIMENTO} - ${p.UNIDADE.DS_UNIDADE}`
                        }
                        getKeyValue={(p) => p.UNIDADE.ID_UNIDADE}
                        {...formMethods}
                        registerOptions={{
                            required: "Insira o produto",
                            valueAsNumber: true,
                        }}
                        onOptionsLoad={setProdutos}
                        className="form-control mb-2"
                    />
                )}
                <label>Categoria de Atendimento</label>
                <SelectCategoriaAtendimento
                    name="ID_CATEGORIA_ATENDIMENTO"
                    ID_MODULO={idModulo}
                    defaultValue={Atendimento?.ID_CATEGORIA_ATENDIMENTO}
                    control={control}
                    rules={{
                        required: "Insira a categoria de Atendimento",
                    }}
                    className="form-control mb-2"
                />
                {TIPO_CASO === "Atendimento" && (
                    <LazySelect
                        label="Subcategoria"
                        name="ID_SUBCATEGORIA_ATENDIMENTO"
                        parentsNames={[
                            "ID_CATEGORIA_ATENDIMENTO",
                            "ID_PRODUTO",
                        ]}
                        controller={ListarSubCategorias}
                        defaultValue={Atendimento?.ID_SUBCATEGORIA_ATENDIMENTO}
                        getDS={(s) => s.DS_SUBCATEGORIA_ATENDIMENTO}
                        getKeyValue={(s) => s.ID_SUB_CATEGORIA_ATENDIMENTO}
                        {...formMethods}
                        registerOptions={{
                            valueAsNumber: true,
                        }}
                        className="form-control mb-2"
                    >
                        <option value={0}></option>
                    </LazySelect>
                )}
                {TIPO_CASO !== "Cobranca" && (
                    <>
                        <label>Peso</label>
                        <select
                            name="ID_TIPO_PESO_ATENDIMENTO"
                            defaultValue={Atendimento?.ID_TIPO_PESO_ATENDIMENTO}
                            disabled={
                                !UserInfor.FUNCOES.some(
                                    (f) =>
                                        f.NM_FUNCAO ===
                                        "ADM_EDITA_PESO_ATENDIMENTO"
                                )
                            }
                            {...formMethods}
                            ref={register()}
                            className="form-control mb-2"
                        >
                            <option value={0}></option>
                            {lstTipoPesoAtendimento?.map((tpa) => (
                                <option
                                    key={tpa.ID_TIPO_PESO_ATENDIMENTO}
                                    value={tpa.ID_TIPO_PESO_ATENDIMENTO}
                                >
                                    {tpa.DS_TIPO_PESO_ATENDIMENTO}
                                </option>
                            ))}
                        </select>
                    </>
                )}

                {ACESSOS.VENDAS.ID_MODULO === idModulo && (
                    <>
                        <label>Data de fechamento</label>
                        <input
                            name="DT_FECHAMENTO"
                            ref={register()}
                            className="form-control mb-2"
                            type="date"
                            defaultValue={
                                dadosOportunidade?.DT_FECHAMENTO?.split("T")[0]
                            }
                        />

                        <label>Valor da oportunidade</label>
                        <input
                            name="VL_OPORTUNIDADE"
                            ref={register({
                                setValueAs: (v: string) =>
                                    Number(MoneyReaisFieldMask.unMask(v)),
                            })}
                            className="form-control mb-2"
                            type="text"
                            defaultValue={formatMoneyReais(
                                dadosOportunidade?.VL_OPORTUNIDADE || 0
                            )}
                            onChange={(e) => {
                                const newValue = MoneyReaisFieldMask(e);

                                e.target.value = newValue;

                                return Number(
                                    MoneyReaisFieldMask.unMask(newValue) || 0
                                );
                            }}
                        />

                        <label>Probabilidade de fechamento (%)</label>
                        <input
                            name="NR_PROBABILIDADE_FECHAMENTO"
                            ref={register()}
                            className="form-control mb-2"
                            type="number"
                            min="0"
                            max="100"
                            onChange={(e) => {
                                let value = Number(e.target.value);
                                if (value > 100) value = 100;
                                if (value < 0) value = 0;
                                e.target.value = value.toString();
                            }}
                            defaultValue={
                                (dadosOportunidade?.NR_PROBABILIDADE_FECHAMENTO ??
                                    0) * 100
                            }
                        />

                        <label>Origem do Lead</label>
                        <LazySelect
                            name="ID_ORIGEM_LEAD"
                            controller={VendasListarOrigensLeadController}
                            getDS={(origem) => origem.DS_ORIGEM_LEAD_COMP}
                            getKeyValue={(origem) => origem.ID_ORIGEM_LEAD}
                            {...formMethods}
                            registerOptions={{
                                valueAsNumber: true,
                            }}
                            className="form-control mb-2"
                            defaultValue={Cliente?.ID_ORIGEM_LEAD}
                        >
                            <option></option>
                        </LazySelect>
                    </>
                )}

                <LazySelect
                    label="Canal de Atendimento"
                    name="ID_TIPO_CANAL_ATENDIMENTO"
                    controller={listarCanalAtendimento}
                    defaultValue={Atendimento?.ID_TIPO_CANAL_ATENDIMENTO}
                    getDS={(c) => c.DS_TIPO_CANAL_ATENDIMENTO}
                    getKeyValue={(c) => c.ID_TIPO_CANAL_ATENDIMENTO}
                    {...formMethods}
                    registerOptions={{
                        required: "Insira o Canal de Atendimento",
                        valueAsNumber: true,
                    }}
                    className="form-control mb-2"
                />
                {ACESSOS.ATENDIMENTO.ID_MODULO === id && (
                    <>
                        <label>Expectativa Real de Conclusão</label>
                        <input
                            name="DT_EXPECTATIVA_NOVA"
                            ref={register()}
                            className="form-control mb-2"
                            type="date"
                            defaultValue={dtExpectativaInicial}
                        />
                        {showJustificativa && (
                            <div>
                                <label>Justificativa</label>
                                <textarea
                                    name="DS_MOTIVO"
                                    ref={register({
                                        required: showJustificativa
                                            ? "Insira a justificativa"
                                            : false,
                                    })}
                                    className={`form-control mb-2 ${
                                        formState.errors.DS_MOTIVO &&
                                        "is-invalid"
                                    }`}
                                />
                                <div className="invalid-feedback">
                                    {formState.errors.DS_MOTIVO
                                        ? formState.errors.DS_MOTIVO.message
                                        : ""}
                                </div>
                            </div>
                        )}{" "}
                    </>
                )}

                <div className="d-flex mt-5">
                    <button
                        type="submit"
                        className="btn btn-block btn-outline-success d-flex align-items-center justify-content-center g-2"
                        disabled={atualizando}
                    >
                        {atualizando && <Spinner size="sm" />}
                        Confirmar atualização
                    </button>
                </div>
            </form>{" "}
        </OrSpinner>
    );
}
